<template>
  <div class="markRecommend">
    <a id="auto" v-on:click="recommend" :href="'line://msg/text/?一起加入好友%0D%0Aline://app/1653867330-D1v8MvzE?keyword=_&c='+this.channelId+'&rec='+this.userId"></a>
    <img src="../assets/mark.png">
  </div>
</template>

<script>
import Vuex from 'vuex'
import { mapGetters } from 'vuex'

export default {
  name: 'markRecommend',
  methods: {
    recommend: function() {
      this.$store.dispatch('recommend', 
      {
        c: this.channelId
      })
    }
  },
  computed: {
    ...mapGetters({
      userId: 'userId'
    }),
    ...mapGetters({
      channelId: 'channelId'
    })
  },
  mounted() {
    document.body.style.backgroundColor="#0A0201"
    // 導至邀請好友 //
    setTimeout(function () {
      document.getElementById('auto').click();
    }, 2000);
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
}
img {
  width: 70%;
  border-radius: 20%;
  margin-top: 10%;
}
</style>


// WEBPACK FOOTER //
// src/components/markRecommend.vue